import React from "react";

export function Logo({ size = 40 }) {
  return (
    <div
      className="wc-logo"
      style={{ width: size, height: size }}
      data-testid="wc-logo"
      aria-label="WordCripto"
    >
      <div className="wc-logo-ring">
        <div className="wc-logo-inner">
          <span className="wc-logo-w">W</span>
        </div>
      </div>
    </div>
  );
}
